module.exports = __webpack_public_path__ + "media/images/territory_landing_pages/hero_banner/component/massage-mobile@3x-a6d0b057f132540faa821006bb841fe7.jpg";